import React, { Component } from "react";
import Search from "../icons/search.svg";
import Close from "../icons/close.svg";
import styled from 'styled-components'

const MultiSelectWrapper = styled.div`
.multiselect-search {
  margin: 5px 0;
  position: relative;
  input {
    background-color: #fff;
    border: 1px solid #ccc;
    display: inline-block;
    height: 20px;
    padding: 4px 6px;
    font-size: 13px;
    line-height: 20px;
    color: #555;
    border-radius: 4px;
    vertical-align: middle;
    width: 100%;
  }
  .search-icon {
    position: absolute;
    width: 16px;
    top: 7px;
    right: 0;
    filter: grayscale(100%) invert(69%) sepia(1%) saturate(1400%) hue-rotate(90deg) brightness(94%) contrast(83%);
  }
  .option-wrapper {
    position: absolute;
    background-color: white;
    box-shadow: 1px 5px 10px rgba(0, 0, 0, .3);
    width: 100%;
    z-index: 1;
    max-height: 300px;
    overflow: auto;
    .option-list {
      list-style: none;
      margin: 0;
      padding: 10px 0;
      li {
        padding: 8px 10px;
        font-size: 14px;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
          cursor: pointer;
          background: #f4f4f4;
        }
      }
    }
  }
  .tag-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    a.tag-clear {
      font-size: 12px;
      color: #808284;
      &:hover {
        text-decoration: underline !important;
        cursor: pointer;
      }
    }
    .tag-box {
      margin-top: 10px;
      .tag {
        margin: 0 10px 5px 0;
        padding: 5px 8px;
        background-color: #f4f4f4;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        img {
          margin-left: 10px;
          filter: brightness(1) invert(1);
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
`

class MultiSelect extends Component {
  state = {
    values: [],
    searchValue: '',
    showList: false
  }
  componentDidMount() {
    window.document.addEventListener('click', this.handleClickOutside);
    this.prepareValue()
  }
  componentWillUnmount() {
    window.document.removeEventListener('click', this.handleClickOutside);
  }
  get filterByValue() {
    const { state: { searchValue }, props: { options, strictFilter } } = this
    const lowerSearch = searchValue.toLowerCase()

    return options.filter(([label, _value]) => {
      const lowerLabel = label.toLowerCase()

      return strictFilter ? lowerLabel.startsWith(lowerSearch) : lowerLabel.includes(lowerSearch)
    })
  }
  get placeholder() {
    const { props: { placeholder } } = this

    return placeholder || 'Search for option'
  }
  prepareValue = () => {
    const { props: { value } } = this

    this.setState({ values: value?.split(',').filter(val => val !== '') || [] })
  }
  clearValues = () => {
    this.setState({ values: [] })
    this.handleClickOutside({ reset: true })
    this.resolveOutput([])
  }
  handleClickOutside = ({ target, reset = false }) => {
    const { state: { showList }, wrapperRef, setShowList } = this
    const outWrapper = wrapperRef && !wrapperRef.contains(target) && showList

    if (outWrapper || reset) {
      setShowList(false)
      this.setState({ searchValue: '' })
    }
  }
  resolveOutput = values => {
    const {
      props: { resolveOutput }
    } = this

    if (resolveOutput) resolveOutput(values)

    return values
  }
  setShowList = value => {
    this.setState({ showList: value })
  }
  removeValue = value => {
    const { state: { values }, resolveOutput } = this

    this.setState({ values: values.filter(key => key != value) })
    resolveOutput(values.filter(key => key != value))
  }
  addValues = value => {
    const { state: { values }, handleClickOutside, resolveOutput } = this

    handleClickOutside({ reset: true })
    if (!values.includes(value)) {
      this.setState({ values: values.concat(value) })
      resolveOutput(values.concat(value))
    }
  }
  onChange = ({ target: { value } }) => {
    this.setState({ searchValue: value })
  }
  renderList = () => {
    const { filterByValue, addValues } = this
    const filteredList = filterByValue.map(([label, _value]) => (
      <li key={`list-${label}`} onClick={() => addValues(label)}>
        {label}
      </li>
    ))

    return (
      <div className="option-wrapper">
        <ul className="option-list">
          {filterByValue.length < 1 ? <li>No options available.</li> : filteredList}
        </ul>
      </div>
    )
  }
  renderTag = value => (
    <span className="tag" key={`value-${value}`}>
      <span>{value}</span>
      <img
          style={{ width: '9px' }}
          src={Close}
          onClick={() => this.removeValue(value)}
        />
    </span>
  )
  renderValues = () => {
    const { state: { values }, renderTag, clearValues } = this
    const allValues = values.map(value => renderTag(value))

    return (
      <div className="tag-wrapper">
        <div className="tag-box">
          {allValues}
        </div>
        {values.length > 1 && <a className='tag-clear' onClick={clearValues}>Clear all</a>}
      </div>
    )
  }
  renderIcon = () => (
    <img
      src={Search}
      className="search-icon"
    />
  )
  render() {
    const {
      props: { id, width = '100%' },
      state: { showList, searchValue },
      renderList,
      renderValues,
      renderIcon,
      onChange,
      setShowList,
      placeholder
    } = this

    return (
      <MultiSelectWrapper>
        <div className="multiselect-search" style={{ width }} ref={el => this.wrapperRef = el}>
          {renderIcon()}
          <input
            value={searchValue}
            autoComplete='off'
            id={id}
            onChange={onChange}
            onKeyDown={() => setShowList(true)}
            placeholder={placeholder}
          />
          {showList && renderList()}
          {renderValues()}
        </div>
      </MultiSelectWrapper>
    )
  }
}

export default MultiSelect
